import { post } from 'services/http';

const signup = user => post('/users', JSON.stringify(user));

const signout = () => post('/logout');

export default { signup, signout };
